const AWS = require("aws-sdk");
const uuid = require("uuid");
const S3_BUCKET = "svgtrace-upload-results-bucket";
const REGION = "us-east-1";
const ACCESS_KEY = "AKIAQHCNDEP2GPK2DYUQ";
const SECRET_ACCESS_KEY = "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";

const s3 = new AWS.S3({
    accessKeyId: ACCESS_KEY,
    secretAccessKey: SECRET_ACCESS_KEY,
    region: REGION,
});
// make function async so that it can be awaited
async function uploadFile(fileContent, bucket, folder = '') {
    let todaysDate = new Date().toISOString().split("T")[0];
    let isoDate = new Date().toISOString();
    // get time of isoDate in milliseconds
    let time = new Date(isoDate).getTime();

    console.log(isoDate);

    if (!JSON.parse(localStorage.getItem("svgTraceUserId"))) {
        const userId = uuid.v4();
        localStorage.setItem("svgTraceUserId", JSON.stringify(userId));
    }

    let convertedBy = JSON.parse(localStorage.getItem("svgTraceUserId"));

    let deviceType = "other";
    if (navigator.userAgent.match(/iPhone/i)) deviceType = "iPhone";
    else if (navigator.userAgent.match(/Android/i)) deviceType = "android";
    else if (navigator.userAgent.match(/iPad/i)) deviceType = "iPad";
    else if (navigator.userAgent.match(/iPod/i)) deviceType = "iPod";
    else if (navigator.userAgent.match(/BlackBerry/i)) deviceType = "blackberry";
    else if (navigator.userAgent.match(/Windows Phone/i))
        deviceType = "windows phone";
    else if (navigator.userAgent.match(/Windows/i)) deviceType = "windows";
    else if (navigator.userAgent.match(/Linux/i)) deviceType = "linux";
    else if (navigator.userAgent.match(/Mac/i)) deviceType = "mac";

    let fileName = `${deviceType}_${convertedBy}_${time}`;
    let extension = ".svg";


    // // store in browser storage
    // sessionStorage.setItem(
    //     "lastConverted",
    //     todaysDate + "/" + fileName + extension
    // );

    // Setting up S3 upload parameters
    const params = {
        Bucket: bucket,
        Key: folder + todaysDate + "/" + fileName + extension, // File name you want to save as in S3
        Body: fileContent,
        ContentType: "image/svg+xml",
        Metadata: {
            'convertedOn': deviceType,
            'convertedBy': convertedBy
        }
    };

    // Uploading files to the bucket
    s3.upload(params, function (err, data) {
        if (err) {
            throw err;
        }
        console.log(`File uploaded successfully. ${data.Location}`);
    });

    var sharelink =
        "https://svgtrace.com/share.html?date=" +
        todaysDate +
        "&fileName=" +
        fileName;

    return sharelink;
};

export default uploadFile;
